export default __webpack_public_path__ + "img/bZiXwQPo.30341dd2.svg";